import React, { Component } from 'react'
import {
	Select,
	Spin,
	Divider,
	Alert,
	// Form,
	// Input,
	// Button,
	// Row,
	// Col,
	// InputNumber,
	// PageHeader,
	// Upload,
	// Modal,
	// Icon
} from 'antd'
// import debounce from 'lodash/debounce'
import WarehousesForm from './WarehousesForm'
import API from '../../../services/API'
// import { objectToFormData } from '../../../services/Utils'

const Option = Select.Option

const INITIAL_DATA = {
	name: '',
	description: '',
    active: 0,
    created_at: '',
    updated_at: '',
}

class WarehouseCreateContainer extends Component {

	state = {
		data: INITIAL_DATA,
		loading: false,
        response: null,
        managers: {
            data: [],
        },
        suburbs: {
            data: [],
        },
        zipcodes: {
            data: [],
        },
	}

	componentDidMount() {
		this.getAdditionalData()
	}

	getAdditionalData = () => {

	}

	getResourceTypeahead = async (resource, uri, stateCallback) => {
		try {
			await this.setState({
				[resource]: {
					...this.state[resource],
					loading: true
				}
			})
			const response = await API.get(uri)

			this.setState({
				[resource]: {
					data: response.data.data.map(stateCallback),
					loading: false
				}
			})
		} catch (error) {
			this.setState({
				[resource]: {
					data: [],
					loading: false
				}
			})
		}
    }

    getManagers = search => {
        this.getResourceTypeahead(
			'managers',
			`/api/users?filter[name]=${search}&filter[role_id]=1`,
			manager => ({
				text: `${manager.name} ${manager.last_name}`,
				value: manager.id
			})
		)
    }

    getZipcode = search => {
        this.getResourceTypeahead(
			'zipcodes',
			`/api/users?filter[name]=${search}`,
			zipcode => ({
				text: `${manager.name} ${manager.last_name}`,
				value: manager.id
			})
		)
    }

    // getSuburbs = search => {
    getSuburbs = () => {
		const { data } = this.state;
        this.getResourceTypeahead(
			'suburbs',
			`/api/suburbs/zipcode/${data.zipcode}`,
			suburb => ({
				text: `${suburb.name}`,
				value: suburb.id
			})
		)
    }

	handleInputChange = (name, limit = -1) => value => {
		let newValue = value
		if (value.target) {
			if (limit === -1) {
				newValue = value.target.value
			} else if (value.target.value.length <= limit) {
				newValue = value.target.value;
			} else {
				return;
			}
		}

		this.setState({
			data: {
				...this.state.data,
				[name]: newValue
			}
		})
	}

	handleSelectChange = name => value => {
		this.setState({
			data: {
				...this.state.data,
				[name]: value
			}
		})
	}

	validateForm = () => {
		const data = JSON.parse(JSON.stringify(this.state.data))

		// data.brand_id = data.brand ? +data.brand.key : ''
		// data.product_type_id = data.productType ? +data.productType.key : ''
		this.save(data)
	}

	save = async data => {

		await this.setState({
			loading: true,
			response: null
		})

		const state = {
			...this.state,
			loading: false
		}

		try {
			const response = await API.post('/api/warehouses', data)
			const subsidiarieId = response.data.id
			state.response = {
				type: 'success',
				message: 'Se creo la Unidad de Medida.',
				subsidiarieId,
			}
		} catch (error) {
			state.response = {
				type: 'error',
				message: error.response
					? error.response.data.message
					: 'Se produjo un error de conexión',
			}
			console.error(error.response)
		}

		this.setState({
			...state,
			// loading: true,
		}, () => {
			setTimeout(() => {
				window.location.reload();
			}, 300);
		})
	}

	getValuesForm = (values) => {
		const formKeys = Object.keys(values);
		let newFormToSend = {};
		for (let index = 0; index < formKeys.length; index++) {
			const element = values[formKeys[index]];
			if (formKeys[index].includes('_id') && element.key) {
				newFormToSend[formKeys[index]] = element.key;
			} else {
				newFormToSend[formKeys[index]] = element;
			}
		}
        this.save(newFormToSend)
	}

	render() {
		return (
			<React.Fragment>
				<div
					style={{
						backgroundColor: 'white',
						borderRadius: 3,
						padding: '8px 16px 16px'
					}}
				>
					<Spin
						spinning={this.state.loading}
						tip="Espere, por favor..."
					>
						<React.Fragment>
							{this.state.response && (
								<Alert
									message={
										this.state.response.type === 'success'
											? 'Éxito'
											: 'Error'
									}
									description={this.state.response.message}
									type={this.state.response.type}
									showIcon
									closable
									onClose={() =>
										this.setState({ response: null })
									}
								/>
							)}
							<Divider>Crear sucursal</Divider>

							<WarehousesForm
								getValuesForm={this.getValuesForm}
							/>

						</React.Fragment>
					</Spin>
				</div>
			</React.Fragment>
		)
	}
}

export default WarehouseCreateContainer
